
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 12,
  viewBox: "0 0 8 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m2.112 6 4.632 4.537a.846.846 0 0 1 0 1.212.888.888 0 0 1-1.238 0L.256 6.606a.846.846 0 0 1 0-1.212L5.506.251a.888.888 0 0 1 1.238 0 .846.846 0 0 1 0 1.212L2.112 6z",
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"8\" height=\"12\" viewBox=\"0 0 8 12\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\">\r\n            <g>\r\n                <g>\r\n                    <path d=\"M2.112 6l4.632-4.537c.341-.335.341-.877 0-1.212-.342-.335-.896-.335-1.238 0L.256 5.394c-.341.335-.341.877 0 1.212l5.25 5.143c.342.335.896.335 1.238 0 .341-.335.341-.877 0-1.212L2.112 6z\" transform=\"translate(-72 -419) translate(71.5 415) matrix(1 0 0 -1 .5 16)\"/>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/arrow.3e48269a05dad3eb32a9d0691c6ace76.svg"),
        {
          React: SvgArrow,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      